/**
 * @typedef {import("../../../../hooks/teacher/students/useGetStudentReportByQuestId").EpisodeInfo} EpisodeInfo
 */

/**
 * Quest Detail Table Row Component
 * @param {{episode: EpisodeInfo}} props
 */
const QuestDetailTableRow = ({ episode }) => {
  return (
    <tr>
      <td>
        <div className="custom-name-cell">
          <span className="custom-name">{episode?.episode}</span>
        </div>
      </td>
      <td>{episode?.best_score}</td>
      <td>{episode?.attempts}</td>
    </tr>
  );
};

export default QuestDetailTableRow;
